import Indicador from "..";
import BAEditFields from "./components/BAEditFields";
// import BAGraficoRelatorio from "./components/BAGraficoRelatorio";
import { BAParamFields } from "./components/BAParamFields";
import baReport from "./reports";
import baReportSummary from "./reports/summary";
import { getTalhaoNomeDisplay, getTalhaoAreaDisplay } from "entity/Indicador/reports/talhaoDisplay";

export default class BA extends Indicador {
    static get fullName() {
        return "Broca Armadilha";
    }

    static get abbrev() {
        return "BA";
    }

    static paramFields(tipoIndicadorField = "") {
        return <BAParamFields tipoIndicadorField={tipoIndicadorField} />;
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <BAEditFields visita={visita} TipoClass={TipoClass} />;
    }

    // static getGraficoRelatorio(h, mediaAgrupadorList, metaUsar, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro) {
    //     return BAGraficoRelatorio(h, mediaAgrupadorList, metaUsar, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro)
    // }

    async renderReport(visita) {
        return baReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return baReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        let qtdAcima = 0;
        const total = apontamento.coletas.length;

        for (let i = 0; i < apontamento.coletas.length; i++) {
            if (apontamento.coletas[i].armadilha !== `Armadilha ${i + 1}`) {
                apontamento.coletas[i].armadilha = `Armadilha ${i + 1}`;
            }

            if (f(apontamento.coletas[i].qtdMariposas) > f(params.indiceMariposas)) {
                apontamento.coletas[i].conforme = "Sim";

                qtdAcima++;
            } else {
                apontamento.coletas[i].conforme = "Não";
            }
        }

        let avgPercentAcima = ((100 * qtdAcima) / total).toFixed(2);

        if (f(avgPercentAcima) > f(params.meta)) {
            apontamento.indice = "Sim";
        } else {
            apontamento.indice = "Não";
        }

        return ((100 * qtdAcima) / total).toFixed(2);
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatusInverte(conformidade, meta, 88.37, 100, 110.46);
    }
    static calcPontosAmostrados(apontamento, paramItems) {
        const result = [];

        for (const item of paramItems) {
            let count = 0;

            for (const coleta of apontamento.coletas) {
                if (this.calcPontoAmostradoColeta(item, coleta.qtdMariposas)) {
                    count++;
                }
            }

            result.push({
                ...item,
                count: count,
            });
        }

        return result;
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: "auto", getValue: (a) => a.dataRef.split("-").reverse().join("/") },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: "auto" },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            {
                title: "Talhão",
                field: "talhao.nome",
                getValue: (a) => getTalhaoNomeDisplay(a),
            },
            {
                title: "Área (ha)",
                field: "talhao.area",
                getValue: (a) => getTalhaoAreaDisplay(a),
            },

            { title: "Turno", field: "turno", width: "auto" },
            { title: "Variedade", field: "insumo", width: "auto" },
            { title: "Variedade (Catálogo)", field: "variedade.variedade", width: "auto" },

            {
                title: "Qtd. Mariposas",
                width: "auto",
                getValue: (a) => {
                    let sum = 0;
                    let arr = a.coletas.map((x) => {
                        if (x.qtdMariposas) {
                            sum = sum + parseFloat(x.qtdMariposas);
                            return x.qtdMariposas;
                        } else {
                            return 0;
                        }
                    });
                    if (sum) {
                        return (sum / arr.length).toFixed(2);
                    } else {
                        return "0";
                    }
                },
            },

            { title: "Índice", field: "indice", width: "auto" },
            {
                title: "Result.",
                field: "conformidade",
                width: 38,
                getColor: (a) => {
                    return IndicadorClass.getColorStatus(
                        IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta),
                    );
                },
            },
        ];
    }

    static getResultStr(apontamento) {
        let arrayColetas = [];
        if (apontamento.coletas) {
            arrayColetas = apontamento.coletas;
        }

        let coletaParametros = "";

        arrayColetas.forEach((ac) => {
            coletaParametros += `armadilha: ${ac.armadilha}, conforme: ${ac.conforme}, Quant. Mariposas: ${ac.qtdMariposas}`;
        });

        return "Índice: " + apontamento.indice + ", " + coletaParametros;
    }
}
